import CommonGroupStructure from "../Constants/GroupDataStructure"; // Import structure

export const fetchFeedDataForGroups = async () => {
  try {
    const response = await fetch("/api/mock/Group/apiGroupMockData.json"); // Fetch from public folder
    const data = await response.json();

    // Ensure data follows CommonFriendStructure
    const formattedData = {
      accUserId: data.accUserId || "",
      groupList: (data.groupList || []).map((group) => ({
        groupid: group.groupid || "",
        grouppic: group.grouppic || "",
        createdOn: group.createdOn || "",
        createdby: group.createdby || "",
        activelevel: group.activelevel || "",
        category: group.category || "", // public or private group
        nmembers: group.nmembers || 0,
        members: (group.members || []).map((member) => ({
          personid: member.personid || "",
          joinedon: member.joinedon || "",
          activelevel: member.activelevel || "",
          adminrights: member.adminrights || "",
          nmessages: member.nmessages || 0,
          nmedia: member.nmedia || 0,
        })),
        totalmesg: group.totalmesg || "",
        messages: (group.messages || []).map((message) => ({
          messageid: message.messageid || "",
          mediaattached: message.mediaattached || "",
          senton: message.senton || "",
          pinned: message.pinned || 0,
          deleteflag: message.deleteflag || 0,
        })),
        timetostore: group.timetostore || "",
      })),
    };

    return formattedData;
  } catch (error) {
    console.error("Error fetching group feed data:", error);
    return { accUserId: "", groupList: [] };
  }
};
